<template>
    <div class="widgetWinn">
        <swiper ref="winnersSlider" class="widgetWinn__list" :options="sliderOptions">
            <swiper-slide v-for="(item, index) in winnerList" :key="index">
                <div class="widgetWinn__list-item" :class="{load: loaded}">
                    <div class="icon" v-html="item.currencyHtmlCode"></div>
                    <div class="inf">
                        <h4>{{ item.name }} {{ $t('front.game.info.winners.won') }} <span
                            v-html="item.currencyHtmlCode"></span> {{ item.amount }}</h4>
                        <p>{{ $t('front.game.info.winners.on_game') }}
                            <router-link :to="gameLink(item)" event="" @click.native.prevent="playForReal(item)">{{
                                    item.game && item.game.title
                                }}
                            </router-link>
                        </p>
                    </div>
                </div>
            </swiper-slide>
        </swiper>
    </div>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar';
import {winnerListScrollDelay, winnerListScrollDuration} from '../../../config/winner';
import {Swiper, SwiperSlide} from "vue-awesome-swiper";
import apiData from "../../mixins/apiData";
import {routesNames} from "../../interfaces/routeInterface";
import {defaultLanguage} from "../../../config/localization";
import {launchGameForReal} from "../../util/game/launchGameManager";

export default {
    name: "WidgetWinner",

    props: ['winnersPerView'],

    components: {
        vueCustomScrollbar,
        Swiper,
        SwiperSlide,
    },

    mixins: [apiData],

    data: function () {
        return {
            sliderInterval: undefined,
            resizeTimeout: undefined,
            sliderOptions: {
                init: true,
                loop: true,
                slidesPerView: this.winnersPerView || 7,
                direction: 'vertical',
                watchSlidesVisibility: true,
                updateOnWindowResize: true,
                watchSlidesProgress: true,
                centerInsufficientSlides: true,
                slideToClickedSlide: false,
            },
        };
    },

    serverPrefetch() {
        return this.fetchData();
    },

    mounted() {
        this.fetchData().then(() => this.setSlidesCount());

        window.addEventListener('resize', this.setResizeTimeout, false);

        this.sliderInterval = setInterval(() => this.swiper.slideNext(winnerListScrollDuration, false), winnerListScrollDelay);
    },

    beforeDestroy() {
        clearInterval(this.sliderInterval);
        this.sliderInterval = null;

        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;

        window.removeEventListener('resize', this.setResizeTimeout, false);
    },

    computed: {
        user() {
            return this.$store.state.user;
        },

        locale() {
            return this.$store.state.locale;
        },

        winnerList() {
            return this.$store.state.winnerList;
        },

        loaded() {
            return this.winnerList.length;
        },

        swiper() {
            return this.$refs.winnersSlider && this.$refs.winnersSlider.$swiper;
        }
    },

    methods: {
        fetchData() {
            return this.$store.dispatch('FETCH_WINNER_LIST', this.createApiData());
        },

        setResizeTimeout() {
            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
                this.resizeTimeout = null;
            }

            this.resizeTimeout = setTimeout(this.setSlidesCount, 200);
        },

        setSlidesCount() {
            if (!this.swiper) return;

            let sliderHeight = this.$refs.winnersSlider && this.$refs.winnersSlider.$el.getBoundingClientRect().height;
            this.swiper.params.slidesPerView = sliderHeight && Math.floor(sliderHeight / 56) || 7;
            this.swiper.update();
        },

        gameLink(item) {
            return this.$router.resolve({
                name: routesNames.GAME_LOBBY_SHORT,
                params: {
                    locale: this.locale === defaultLanguage ? null : this.locale,
                    alias: item.game && item.game.alias,
                },
            }).resolved.fullPath;
        },

        playForReal(item) {
            launchGameForReal(this, item.game);
        },
    },
}
</script>

<style lang="sass" scoped>
@import "sass/components/games/WidgetWinner"
</style>
